msgid ""
msgstr ""
"POT-Creation-Date: 2023-11-09 14:20+0100\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: no\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

msgid "{0, plural, one {coupon on your account!} other {coupons on your account!}}"
msgstr "{0, plural, one {rabattkupong på kontoen din!} other {rabattkuponger på kontoen din!}}"

msgid "{0, plural, one {friend} other {friends}}"
msgstr "{0, plural, one {venn} other {venner}}"

msgid "{0, plural, one {Our measurements show that your tires may soon be, or are already, below the legal tread depth.} other {Our measurements show that you have multiple tire sets where your tires may soon be, or are already, below the legal tread depth.}}"
msgstr "{0, plural, one {Våre målinger viser at dekkene dine snart kan være, eller allerede er, under den lovlige mønsterdybden.} other {Våre målinger viser at du har flere dekksett hvor dekkene dine snart kan være, eller allerede er, under den lovlige mønsterdybden.}}"

msgid "{carName} has an active tire hotel contract, but we do not provide tire hotel services in this area - please contact us at hei@noddi.no"
msgstr "{carName} har en aktiv avtale med dekkhotell, men vi tilbyr ikke dekkhotell-tjenester i dette området - vennligst kontakt oss på hei@noddi.no"

msgid "{carName} has an active tire hotel contract, but we do not provide tire hotel services in this area - please contact us at hei@noddi.no if you need help with this"
msgstr "{carName} har en aktiv dekkhotellavtale, men vi tilbyr ikke dekkhotelltjenester i dette området - vennligst kontakt oss på hei@noddi.no hvis du trenger hjelp med dette"

msgid "{frontQuantity, plural, one {Front tire} other {Front tires}}"
msgstr "{frontQuantity, plural, one {fordekk} other {fordekk}}"

msgid "{numberOfSelectedCars, plural, one {Car} other {Cars}}"
msgstr "{numberOfSelectedCars, plural, one {Bil} other {Biler}}"

msgid "{rearQuantity, plural, one {Rear tire} other {Rear tires}}"
msgstr "{rearQuantity, plural, one {bakdekk} other {bakdekk}}"

msgid "A confirmation message will be sent to you via SMS shortly"
msgstr "Du vil snart motta en bekreftelse via SMS"

msgid "AB12345"
msgstr "AB12345"

msgid "ABC123"
msgstr "ABC123"

msgid "Activate coupons"
msgstr "Aktiver kuponger"

msgid "Activate membership"
msgstr "Aktiver medlemskap"

msgid "Activated"
msgstr "Aktivert"

msgid "Add"
msgstr "Legg til"

msgid "Add a comment"
msgstr "Legg til en kommentar"

msgid "Add one or more cars"
msgstr "Legg til én eller flere biler"

msgid "Amount"
msgstr "Beløp"

msgid "An overview of all your active memberships and recurring benefits"
msgstr "En oversikt over alle dine aktive medlemskap og faste fordeler. Rabattene vil automatisk bli lagt til handlekurven"

msgid "and"
msgstr "og"

msgid "Any notes to technician?"
msgstr "Beskjed til tekniker?"

msgid "Anything more we should know?"
msgstr "Noe mer vi bør vite?"

msgid "Appointment Scheduling"
msgstr "Timebestilling"

msgid "Are you sure you want to remove this offer?"
msgstr "Er du sikker på at du vil fjerne dette tilbudet?"

msgid "At the agreed time, one of our technicians will come to your home and install the new tires quickly and safely."
msgstr "På avtalt tid vil en av våre teknikere komme hjem til deg og installere de nye dekkene raskt og trygt."

msgid "Back"
msgstr "Tilbake"

msgid "Booking canceled"
msgstr "Bestilling kansellert"

msgid "Booking confirmed"
msgstr "Bestilling bekreftet"

msgid "Booking reference"
msgstr "Bookingreferanse"

msgid "Booking reference : {slug}"
msgstr "Bookingreferanse : {slug}"

msgid "booking_time_window_not_bookable"
msgstr "Valgte tidsluker har dessverre blitt fylt opp. Vennligst velg en annen luke i forrige steg"

msgid "Bookings"
msgstr "Bestillinger"

msgid "Cancel"
msgstr "Kanseller"

msgid "Cancel booking"
msgstr "Kanseller booking"

msgid "Cancel booking?"
msgstr "Kansellere bestilling?"

msgid "Cancel your booking"
msgstr "Kanseller bestilling"

msgid "Canceled"
msgstr "Kansellert"

msgid "Canceling the booking is completely free of charge. Cancellation is available until 18:00 the day before the booking date."
msgstr "Kansellering av din booking er kostnadsfritt. Avbestilling er tilgjengelig fram til kl. 18:00 dagen før avtalen din"

msgid "capacity_contribution_already_exists"
msgstr "Du har allerede lagt til tilgjengelighet for en av datoene for dette lisensområdet"

msgid "Car registered in another country?"
msgstr "Bil registrert i et annet land?"

msgid "Car wash"
msgstr "Bilpleie"

msgid "car_not_found"
msgstr "Vi fant dessverre ingen bil med reg. nummer"

msgid "Cars"
msgstr "Biler"

msgid "Cars and services"
msgstr "Biler og tjenester"

msgid "cars on our tire hotel"
msgstr "biler på vårt dekkhotell"

msgid "Change booking time?"
msgstr "Endre tidspunkt?"

msgid "Change time"
msgstr "Endre tidspunkt"

msgid "Changed my plans"
msgstr "Endret planene mine"

msgid "Changing the booking time is free. Rescheduling is available until 18:00 the day before the booking date."
msgstr "Endring av tidspunkt er kostnadsfritt og er tilgjengelig frem til kl. 18:00 dagen før avtalen din"

msgid "Chat"
msgstr "Chat"

msgid "Checking availability in your area..."
msgstr "Sjekker tilgjengelighet i ditt område..."

msgid "Choose"
msgstr "Velg"

msgid "Choose from another address?"
msgstr "Velg en annen adresse?"

msgid "Choose from your addresses?"
msgstr "Velg blant adressene dine?"

msgid "Choose time"
msgstr "Velg tid"

msgid "Choose time and address"
msgstr "Velg tid og adresse"

msgid "Choose tires from the offer we have prepared based on the tire dimensions your car is registered with at the Norwegian Public Roads Administration."
msgstr "Velg dekk fra tilbudet vi har forberedt basert på dekkdimensjonene bilen din er registrert med hos Statens vegvesen."

msgid "Chose a different solution"
msgstr "Noen andre fikset"

msgid "Clear all"
msgstr "Fjern alle"

msgid "Clear filters"
msgstr "Nullstill filtre"

msgid "Close"
msgstr "Lukk"

msgid "Communication"
msgstr "Kommunikasjon"

msgid "Company name"
msgstr "Navn på din bedrift"

msgid "Company organization number"
msgstr "Bedriftens organisasjonsnummer"

msgid "Completed"
msgstr "Fullført"

msgid "Completed by our technician"
msgstr "Fullført av vår tekniker"

msgid "Confirm"
msgstr "Bekreft"

msgid "Confirm and go to payment"
msgstr "Bekreft og gå til betaling"

msgid "Confirm booking"
msgstr "Bekreft bestilling"

msgid "Confirm membership"
msgstr "Bekreft medlemskap"

msgid "Confirm order"
msgstr "Bekreft bestilling"

msgid "Confirm order and pay"
msgstr "Bekreft bestilling og betal"

msgid "Confirm password"
msgstr "Bekreft passord"

msgid "Confirmation"
msgstr "Bekreftelse"

msgid "Confirmed"
msgstr "Bekreftet"

msgid "Copied!"
msgstr "Kopiert!"

msgid "Copy referral link"
msgstr "Kopier vervelenke"

msgid "Could not find car in Statens Vegvesen register"
msgstr "Fant ikke bilen i registeret til Statens Vegvesen"

msgid "Coupons"
msgstr "Kuponger"

msgid "Create user"
msgstr "Opprett bruker"

msgid "credentials_invalid"
msgstr "Passordet og/eller brukernavnet er feil"

msgid "Date of birth"
msgstr "Fødselsdato"

msgid "Date of birth is not valid"
msgstr "Fødselsdatoen er ikke gyldig"

msgid "Date of birth is required"
msgstr "Fødselsdato er påkrevd"

msgid "Date of birth must be in the format DD.MM.YYYY"
msgstr "Fødselsdato må være i formatet DD.MM.ÅÅÅÅ"

msgid "dd.mm.yyyy"
msgstr "dd.mm.åååå"

msgid "deliver these services to your address"
msgstr "leverer disse tjenestene til din adresse"

msgid "Delivery"
msgstr "Levering"

msgid "Delivery cost"
msgstr "Leveringskostnad"

msgid "Details"
msgstr "Detaljer"

msgid "Didn't receive sms?"
msgstr "Ikke mottatt sms?"

msgid "Discount"
msgstr "Rabatt"

msgid "Discounts"
msgstr "Rabatter"

msgid "Do you need help with anything else?"
msgstr "Trenger du hjelp med noe annet?"

msgid "Do you need help with car washing, tire changes, or tire hotel for the vehicles in your company?"
msgstr "Trenger du hjelp til bilvask, dekkskift eller dekkhotell på bilene i deres bedrift?"

msgid "Does this look correct?"
msgstr "Ser dette riktig ut?"

msgid "Don't remember your NAF membership number?"
msgstr "Husker du ikke ditt NAF-medlemsnummer?"

msgid "E.g. AB12345"
msgstr "F.eks. AB12345"

msgid "E.g. ABC123"
msgstr "F.eks ABC123"

msgid "Earlier"
msgstr "Tidligere"

msgid "Economy"
msgstr "Økonomi"

msgid "Edit"
msgstr "Endre"

msgid "Edit account"
msgstr "Endre konto"

msgid "Edit account information"
msgstr "Endre kontoinformasjon"

msgid "Edit address"
msgstr "Endre adresse"

msgid "Edit comment"
msgstr "Endre kommentar"

msgid "Edit services"
msgstr "Endre tjenester"

msgid "Edit time"
msgstr "Endre tid"

msgid "Email"
msgstr "E-post"

msgid "End agreement"
msgstr "Avslutt avtale"

msgid "English"
msgstr "Engelsk"

msgid "Enjoying Noddi so far?"
msgstr "Liker du Noddi så langt?"

msgid "Enter code"
msgstr "Skriv inn koden"

msgid "Enter discount code to connect the membership benefits to your account"
msgstr "Skriv inn rabattkoden for å koble medlemsfordelene til kontoen din"

msgid "Enter number to receive a verification code"
msgstr "Skriv inn nummeret ditt, så sender vi deg en verifiseringskode"

msgid "Estimated delivery"
msgstr "Forventet leveringstid"

msgid "EU check"
msgstr "EU-kontroll"

msgid "EU tire label"
msgstr "EU dekkmerking"

msgid "Failed to register your details, please try again"
msgstr "Kunne ikke registrere opplysningene dine, prøv igjen"

msgid "Feel free to reach out to us in the chat or at"
msgstr "Ta gjerne ta kontakt med oss på chat eller på"

msgid "Feel free to share more details"
msgstr "Del gjerne om det er noe annet"

msgid "Fill out the form, and we will get in touch"
msgstr "Fyll ut skjemaet, så tar vi kontakt"

msgid "Finalizing your booking"
msgstr "Fullfører din bestilling"

msgid "First name"
msgstr "Fornavn"

msgid "for your"
msgstr "for din"

msgid "Found a cheaper option"
msgstr "Fant et billigere alternativ"

msgid "Free"
msgstr "Gratis"

msgid "from"
msgstr "fra"

msgid "From"
msgstr "Fra"

msgid "Front tires"
msgstr "Fordekk"

msgid "Fuel economy"
msgstr "Drivstofføkonomi"

msgid "Full"
msgstr "Fullt"

msgid "General details"
msgstr "Generelle detaljer"

msgid "General info"
msgstr "Om bilen"

msgid "genericErrorMessage"
msgstr "Obs.. det ser ut som noe gikk galt"

msgid "Get 10 % off on every service"
msgstr "Få 10% rabatt på alle tjenester"

msgid "Give feedback"
msgstr "Gi tilbakemelding"

msgid "Go Back"
msgstr "Tilbake"

msgid "Go to date"
msgstr "Hopp til dato"

msgid "Go to homepage"
msgstr "Gå til hjemside"

msgid "Height"
msgstr "Høyde"

msgid "Hello again"
msgstr "Hei igjen"

msgid "Help to carry tires"
msgstr "Hjelp til å bære dekkene"

msgid "Help us improve by sharing your thoughts"
msgstr "Hjelp oss å bli bedre ved å dele tankene dine"

msgid "here"
msgstr "her"

msgid "Hi"
msgstr "Hei,"

msgid "Home delivery and wheel change"
msgstr "Hjemlevering og dekkskift"

msgid "Hooray!"
msgstr "Hurra!"

msgid "How easy did you find it to book the service?"
msgstr "Hvor enkelt syntes du det var å booke tjenesten?"

msgid "How it works"
msgstr "Sånn fungerer det"

msgid "How likely are you to recommend Noddi to someone else?"
msgstr "Hvor sannsynlig er det at du vil anbefale Noddi til noen andre?"

msgid "How polite did you find the technician to be? (optional)"
msgstr "Hvor høflig syntes du teknikeren var? (valgfri)"

msgid "How satisfied are you with the result of the job?"
msgstr "Hvor tilfreds er du med resultatet på jobben?"

msgid "How was your experience?"
msgstr "Hvordan var opplevelsen din?"

msgid "How would you like to pay?"
msgstr "Hvordan ønsker du å betale?"

msgid "How would you rate our communication before the appointment?"
msgstr "Hvor bra synes du kommunikasjonen vår før avtalen var?"

msgid "How you want to return your tires?"
msgstr "Hvordan vil du at vi returnerer dekkene dine?"

msgid "Hurray"
msgstr "Hurra"

msgid "Hurray!"
msgstr "Hurra!"

msgid "I have referred"
msgstr "Jeg har invitert"

msgid "If you don't want to use your prepared booking this season, please cancel it. This way, we won't send you any further reminders."
msgstr "Hvis du ikke ønsker å din foreslåtte bestilling denne sesongen, ber vi deg vennligst avbestille den. Da slipper du flere påminnelser fra oss."

msgid "if you have any questions"
msgstr "hvis du har noen spørsmål"

msgid "If you have any questions, contact us at bedrift@noddi.no"
msgstr "Hvis du har noen spørsmål, kontakt oss på bedrift@noddi.no"

msgid "If you have ordered a tire change and have not added carrying assistance, you must place the tires less than 10 meters away from the car, on ground level. We can help you carry them, but there will be a small additional fee."
msgstr "Hvis du ikke har bestilt bærehjelp, må dekkene stå på bakkeplan og være maks 10 meter fra bilen – ellers hjelper vi gjerne, mot betaling."

msgid "If you still wish to change, please create a new booking with different items and cancel this one."
msgstr "Hvis du fortsatt ønsker å endre, vennligst opprett en ny booking med andre tjenester og avbestill denne."

msgid "If you want to be notified when we're in your area, enter your details below and we'll keep you updated!"
msgstr "Hvis du vil bli varslet når vi er i ditt område, skriv inn dine opplysninger nedenfor, så holder vi deg oppdatert!"

msgid "If you want to create a booking right away, you can easily do that through your homepage"
msgstr "Hvis du ønsker å opprette en booking med en gang, kan du enkelt gjøre det via hjemmesiden"

msgid "if you're having trouble logging in"
msgstr "hvis du har problemer med å logge inn"

msgid "Impersonate user"
msgstr "Impersonate bruker"

msgid "In good condition"
msgstr "I god stand"

msgid "In Norway, the minimum requirement for tread depth on summer tires is 1.6 mm. It is illegal to drive with summer tires under 1.6 mm. We recommend changing tires when the tread depth is below 3 mm. When the tread depth is below 3 mm, the braking distance increases considerably, and the tire loses its performance."
msgstr "I Norge er minstekravet til mønsterdybde på sommerdekk 1.6 mm. Det er ulovlig å kjøre med sommerdekk som har under 1.6 mm. Vi anbefaler å bytte dekk når mønsterdybden er under 3 mm. Når mønsterdybden er under 3 mm øker bremselengden betraktelig, og dekket mister sine egenskaper."

msgid "In Norway, the minimum requirement for tread depth on winter tires is 3 mm. It is illegal to drive with winter tires that are under 3 mm. We recommend changing tires when the tread depth is below 4 mm. When the tread depth is below 4 mm, the braking distance increases considerably, and the tire loses its performance."
msgstr "I Norge er minstekravet til mønsterdybde på vinterdekk 3 mm. Det er ulovlig å kjøre med vinterdekk som har under 3 mm. Vi anbefaler å bytte dekk når mønsterdybden er under 4 mm. Når mønsterdybden er under 4 mm øker bremselengden betraktelig, og dekket mister sine egenskaper."

msgid "In the meantime, if you have any questions, contact us at hei@noddi.no"
msgstr "I mellomtiden, hvis du har noen spørsmål, kontakt oss på hei@noddi.no."

msgid "Incorrect discount code, please try again"
msgstr "Feil rabattkode, vennligst prøv igjen"

msgid "Information about your agreement with Noddi"
msgstr "Nyttig informasjon om din avtale hos Noddi"

msgid "Inside car wash"
msgstr "Innvendig bilvask"

msgid "Invalid license plate number"
msgstr "Ugyldig registreringsnummer"

msgid "invalid_code"
msgstr "Koden er ikke gyldig"

msgid "invalid_phone_number"
msgstr "Telefonnummeret er ikke gyldig"

msgid "invalid_verification_code"
msgstr "Verifiseringskoden er ikke gyldig"

msgid "Invite a friend"
msgstr "Inviter en venn"

msgid "Invite friends to Noddi"
msgstr "Inviter venner til Noddi"

msgid "Invite one or more friends"
msgstr "Inviter én eller flere venner"

msgid "Invoiced"
msgstr "Fakturert"

msgid "is currently not offered together with the following services:"
msgstr "er for øyeblikket ikke tilgjengelig sammen med følgende tjenester:"

msgid "Is valid"
msgstr "Er gyldig"

msgid "It's time for your tire change again! We've reserved a spot for you"
msgstr "Det er på snart på tide med dekkskift igjen! Vi har holdt av en plass til deg"

msgid "Language"
msgstr "Språk"

msgid "Last approval"
msgstr "Siste godkjenning"

msgid "Last name"
msgstr "Etternavn"

msgid "Later"
msgstr "Senere"

msgid "Left back"
msgstr "Venstre bak"

msgid "Left front"
msgstr "Venstre front"

msgid "Length"
msgstr "Lengde"

msgid "Loading"
msgstr "Laster inn"

msgid "Loading addresses..."
msgstr "Laster adresser..."

msgid "Location"
msgstr "Sted"

msgid "Location was not convenient"
msgstr "Adressen var feil"

msgid "Locking in the details – almost done..."
msgstr "Låser inn detaljene - nesten ferdig..."

msgid "Log in"
msgstr "Logg inn"

msgid "Log out"
msgstr "Logg ut"

msgid "Make sure the car is unlocked or that we have the key—we'll handle the rest"
msgstr "Sørg for at bilen er ulåst eller at vi har nøkkelen – vi ordner resten"

msgid "Manage my tire hotel"
msgstr "Administrer mitt dekkhotell"

msgid "Matching you with a certified technician..."
msgstr "Matcher deg med en sertifisert tekniker..."

msgid "Measured at"
msgstr "Dekkmåling utført"

msgid "Membership benefits"
msgstr "Medlemsfordeler"

msgid "Membership number can only contain numbers"
msgstr "Medlemsnummeret kan bare inneholde tall"

msgid "Membership number is required"
msgstr "Medlemsnummer er påkrevd"

msgid "Membership registered"
msgstr "Medlemskap registrert"

msgid "Menu"
msgstr "Meny"

msgid "Missing measurements"
msgstr "Mangler målinger"

msgid "Most of our time slots are free, but for shorter, more specific time slots, there is a small additional charge. This is due to the added limitations these time slots create for our scheduling."
msgstr "De fleste av våre tidsluker er gratis, men for kortere tidsluker tilkommer det en liten tilleggsavgift. Dette skyldes at spesifikke tidsluker begrenser planleggingen vår, noe som igjen øker kostnadene våre."

msgid "Must consist of at least 4 numbers"
msgstr "Må inneholde minst 4 tall"

msgid "Must provide a valid email address"
msgstr "Må oppgi en gyldig e-postadresse"

msgid "My account"
msgstr "Min konto"

msgid "My addresses"
msgstr "Mine adresser"

msgid "My cars"
msgstr "Mine biler"

msgid "My coupons"
msgstr "Mine rabattkuponger"

msgid "My profile"
msgstr "Min side"

msgid "My referral link"
msgstr "Min vervelenke"

msgid "NAF benefits"
msgstr "NAF fordeler"

msgid "NAF cares about the safety of all its members and therefore it is important that you have the right tires on at the right time. But why drive to the workshop, when it can come to you? Noddi is car made easy!"
msgstr "NAF bryr seg om sikkerheten til alle medlemmene sine, og derfor er det viktig at du har riktige dekk på til rett tidspunkt. Men hvorfor kjøre til verkstedet, når det kan komme til deg? Noddi gjør bilhold enkelt!"

msgid "NAF membership number"
msgstr "NAF medlemsnummer"

msgid "New {season} for"
msgstr "Nye {season} til"

msgid "New booking"
msgstr "Ny bestilling"

msgid "new_user_not_eligible_for_campaign"
msgstr "Denne kampanjen er kun for nye medlemmer. Vi aktiverer derfor ikke kupongene på profilen din"

msgid "Next"
msgstr "Neste"

msgid "Next check"
msgstr "Neste kontroll"

msgid "No addresses found"
msgstr "Fant ingen adresser"

msgid "No bookings"
msgstr "Ingen bestillinger"

msgid "No coupons found"
msgstr "Fant ingen kuponger"

msgid "No membership found"
msgstr "Fant ingen medlemskap tilknyttet din profil"

msgid "Noddi for your company"
msgstr "Noddi for bedrift"

msgid "Noddi wheel change"
msgstr "Noddi dekkskift"

msgid "Noise level"
msgstr "Støynivå"

msgid "Norway"
msgstr "Norge"

msgid "Norwegian"
msgstr "Norsk"

msgid "Not completed"
msgstr "Ikke fullført"

msgid "Not interested?"
msgstr "Ikke interessert?"

msgid "Notify Me"
msgstr "Varsle meg"

msgid "of"
msgstr "av"

msgid "Once the job is complete, you'll receive a payment link via SMS"
msgstr "Når jobben er fullført vil du motta en betalingslenke via SMS"

msgid "Once you approve the offer, we will order the tires from our central warehouse and arrange a time for installation at your home."
msgstr "Når du godtar tilbudet, vil vi bestille dekkene fra vårt sentrallager og avtale en tid for montering hjemme hos deg."

msgid "Optional note if any extra information is needed, like where to find tires, keys etc."
msgstr "Eventuell tilleggsinformasjon, typisk hvor man kan finne dekk, nøkler etc."

msgid "Optional note if any extra information is needed..."
msgstr "Valgfri melding hvis det er nødvendig med ytterligere informasjon..."

msgid "Order confirmation"
msgstr "Bestillingsbekreftelse"

msgid "Order confirmed"
msgstr "Bestilling bekreftet"

msgid "Order details"
msgstr "Bestillingsdetaljer"

msgid "Order processing"
msgstr "Ordrebehandling"

msgid "Order reference"
msgstr "Bestillingsreferanse"

msgid "Order status"
msgstr "Status på din bestilling"

msgid "Order wheel change"
msgstr "Bestill dekkskift"

msgid "Other"
msgstr "Annet"

msgid "Other?"
msgstr "Annet?"

msgid "Our measurements show that your tires may soon be, or are already, below the legal tread depth."
msgstr "Målingene våre viser at dekkene dine nærmer seg eller allerede er under den lovlige grensen for mønsterdybde."

msgid "Our team is preparing your tires and assigning your appointment to a skilled technician. You don’t need to do anything — just make sure you’re available around the scheduled time."
msgstr "Vårt team klargjør dekkene dine og tildeler timen din til en dyktig tekniker. Du trenger ikke å gjøre noe — bare sørg for at du er tilgjengelig rundt det planlagte tidspunktet."

msgid "Our team will are processing your order. You will receive an SMS with estimated delivery time when the tires are ordered from our main warehouse."
msgstr "Vårt team behandler bestillingen din. Du vil motta en SMS med estimert leveringstid når dekkene er bestilt fra vårt hovedlager."

msgid "Our team will process your order immediately and prepare your tires for shipment and installation. You will receive an SMS with estimated delivery time."
msgstr "Vårt team vil behandle bestillingen din umiddelbart og klargjøre dekkene dine for forsendelse og montering. Du vil motta en SMS med estimert leveringstid."

msgid "Outside car wash"
msgstr "Utvendig bilvask"

msgid "Page Not Found"
msgstr "Fant ikke siden"

msgid "Page size"
msgstr "Rader per side "

msgid "Paid"
msgstr "Betalt"

msgid "Password"
msgstr "Passord"

msgid "password_verification_failed"
msgstr "passordverifisering mislyktes"

msgid "Passwords must match"
msgstr "Passordene må være like"

msgid "Pay"
msgstr "Betal"

msgid "Pay now"
msgstr "Betal nå"

msgid "Payment"
msgstr "Betaling"

msgid "Payment cancelled"
msgstr "Betalingen er avbrutt."

msgid "Payment completed"
msgstr "Betaling fullført"

msgid "Payment failed"
msgstr "Betalingen mislyktes"

msgid "Payment is made digitally according to the agreement on this page, by credit card or Vipps."
msgstr "Betaling skjer digitalt etter avtalen på denne siden, med kredittkort eller Vipps."

msgid "pcs"
msgstr "stk"

msgid "per tire"
msgstr "per dekk"

msgid "Per tire"
msgstr "Per dekk"

msgid "Phone number"
msgstr "Telefonnummer"

msgid "Phone number is not valid"
msgstr "Telefonnummeret er ikke gyldig"

msgid "phone_number_verification_error"
msgstr "Telefonnummeret du oppga er ikke gyldig"

msgid "Pick time"
msgstr "Velg tid"

msgid "Pickup of tires from another tire hotel"
msgstr "Henting av dekk fra et annet dekkhotell"

msgid "pin_code_verification_error"
msgstr "Verifiseringskoden du oppga er ugyldig"

msgid "Place your tires on the ground, within 10 meters of the car. If not, there wil be an extra charge"
msgstr "Plasser dekkene dine på bakken, innenfor 10 meter fra bilen. Hvis ikke, vil det påløpe en ekstra kostnad"

msgid "Please contact support at hei@noddi.no if the problem persists"
msgstr "Vennligst kontakt support på hei@noddi.no dersom problemet vedvarer"

msgid "Please create a new booking and cancel this one."
msgstr "Vennligst opprett en ny bestilling og avbestill denne."

msgid "Please elaborate"
msgstr "Vennligst utdyp"

msgid "Please ensure the street number is included in the address"
msgstr "Vennligst sørg for at gatenummeret er inkludert i adressen"

msgid "Please enter an address with a street number so that we can check if we can come to you!"
msgstr "Vennligst skriv inn en adresse med gatenummer slik at vi kan se om vi kan komme til deg!"

msgid "Please fill in your information"
msgstr "Vi trenger litt info om deg "

msgid "Please select a different address or remove the following services"
msgstr "Prøv en annen adresse eller fjern disse tjenestene"

msgid "Please select an address with a valid city"
msgstr "Vennligst velg en adresse med en gyldig by"

msgid "Please select an address with a valid street name"
msgstr "Vennligst velg en adresse med et gyldig gatenavn"

msgid "Please select an address with a valid street number"
msgstr "Vennligst velg en adresse med et gyldig gatenummer"

msgid "Please select an address with a valid zip code"
msgstr "Vennligst velg en adresse med gyldig postnummer"

msgid "Please share your experience with us"
msgstr "Gjerne del din erfaring med oss..."

msgid "Please try again. If the problem persists, don't hesitate to reach out to us at hei@noddi.no"
msgstr "Vennligst prøv igjen. Hvis problemet vedvarer, ta kontakt med oss på hei@noddi.no"

msgid "Popular"
msgstr "Populær"

msgid "Premium"
msgstr "Premium"

msgid "Previous bookings"
msgstr "Tidligere bestillinger"

msgid "Price"
msgstr "Pris"

msgid "Problems with the last time slot"
msgstr "Problemer med siste tidsluke"

msgid "Processing"
msgstr "Under behandling"

msgid "Profile updated successfully"
msgstr "Profilen din er oppdatert"

msgid "Read more"
msgstr "Les mer"

msgid "Read more about delivery"
msgstr "Les mer om levering"

msgid "Ready for mounting?"
msgstr "Klar for montering?"

msgid "Ready to confirm your order?"
msgstr "Klar til å bekrefte bestillingen din?"

msgid "Rear tires"
msgstr "Bakdekk"

msgid "Receipt"
msgstr "Kvittering"

msgid "Refer a friend and you both get 150 kr in discounts on your next booking"
msgstr "Inviter en venn og begge får 150 kr i rabatt på neste bestilling"

msgid "Refer a friend and you both get 150 kr in discounts on your next booking. Save money and time together with Noddi!"
msgstr "Inviter en venn og begge får 150 kr i rabatt på neste bestilling. Spar penger og tid sammen med Noddi!"

msgid "Referral link copied to clipboard"
msgstr "Vervelenken er kopiert til utklippstavlen"

msgid "Referred friends"
msgstr "Inviterte venner"

msgid "Register using date of birth instead"
msgstr "Registrer deg med fødselsdato i stedet"

msgid "Register with membership number"
msgstr "Registrer med medlemsnummer"

msgid "Remove"
msgstr "Fjern"

msgid "Remove car from booking"
msgstr "Fjern bilen fra bestillingen"

msgid "Repair of puncture"
msgstr "Reparasjon av punktering"

msgid "Required"
msgstr "Påkrevd"

msgid "Resend"
msgstr "Send på nytt"

msgid "Rewards you have received for referring friends"
msgstr "Rabatter du har mottatt for å invitere venner"

msgid "Right back"
msgstr "Høyre bak"

msgid "Right front"
msgstr "Høyre front"

msgid "Rim wash"
msgstr "Felg vask"

msgid "Save"
msgstr "Lagre"

msgid "Saved addresses"
msgstr "Lagrede adresser"

msgid "Search by license plate"
msgstr "Søk etter registreringsnummer"

msgid "See booking"
msgstr "Se bestilling"

msgid "See details"
msgstr "Se detaljer"

msgid "See measurements"
msgstr "Se målinger"

msgid "See more"
msgstr "Se mer"

msgid "See offer for new tires"
msgstr "Se tilbud på nye dekk"

msgid "Select"
msgstr "Velg"

msgid "Select a user from the list to view the application as them and take actions on their behalf"
msgstr "Velg en bruker fra listen for å se søknaden som dem og ta handlinger på deres vegne"

msgid "Select and order tire set"
msgstr "Velg og bestill dekksettet"

msgid "Select one or more"
msgstr "Velg en eller flere"

msgid "selected"
msgstr "valgte"

msgid "Selected cars"
msgstr "Valgte biler"

msgid "Selected time window"
msgstr "Valgt tidsluke"

msgid "Send code"
msgstr "Send kode"

msgid "Send feedback"
msgstr "Send tilbakemelding"

msgid "Send in"
msgstr "Send inn"

msgid "Send in feedback"
msgstr "Send inn tilbakemelding"

msgid "Services provided by"
msgstr "Tjenestene leveres av"

msgid "Show all"
msgstr "Vis alle"

msgid "Show less"
msgstr "Vis færre"

msgid "Sold out"
msgstr "Utsolgt"

msgid "Some items in your booking cannot be delivered to this address"
msgstr "Noen tjenester i bestillingen din kan ikke leveres til denne adressen"

msgid "Something didn't go as planned while filling in your booking details. Please try again"
msgstr "Noe gikk galt i bestillingen. Vennligst forsøk å opprette en ny bestilling"

msgid "Something went wrong"
msgstr "Noe gikk galt"

msgid "Something went wrong with fetching the addresses, please try again"
msgstr "Noe gikk galt med henting av adressene, vennligst prøv igjen"

msgid "Soon worn out"
msgstr "Snart utslitt"

msgid "Sorry, we don't deliver to this address yet"
msgstr "Beklager, vi leverer ikke til denne adressen ennå"

msgid "Standard"
msgstr "Standard"

msgid "Standards for winter and summer tires"
msgstr "Standarder for vinter -og sommerdekk"

msgid "Stone chip repair"
msgstr "Steinsprutreparasjon"

msgid "Studded tires"
msgstr "Piggdekk"

msgid "Suggested booking"
msgstr "Foreslått booking"

msgid "summer tires"
msgstr "sommerdekk"

msgid "Summer tires"
msgstr "Sommerdekk"

msgid "Surname"
msgstr "Etternavn"

msgid "Sweden"
msgstr "Sverige"

msgid "Swedish"
msgstr "Svenska"

msgid "Tell us where your car is parked. We'll come to you, so you can spend your time on other things"
msgstr "Fortell oss hvor bilen din står parkert. Vi kommer til deg så du kan bruke tiden på andre ting"

msgid "Thank you for your feedback!"
msgstr "Takk for tilbakemeldingen din!"

msgid "Thank you!"
msgstr "Tusen takk!"

msgid "Thank you! We’ll Keep You Updated"
msgstr "Takk! Vi vil holde deg oppdatert."

msgid "Thanks for using Noddi!"
msgstr "Takk for at du bruker Noddi!"

msgid "Thanks, we have received your payment"
msgstr "Takk, vi har mottatt betalingen din"

msgid "Thanks! You will receive an invoice shortly"
msgstr "Takk! Du vil snart motta en faktura."

msgid "The benefits have already been linked to your account, and discounts will be automatically applied to your shopping cart"
msgstr "Dine faste fordeler er tilknyttet din konto! Rabattene vil automatisk bli lagt til handlekurven"

msgid "The code you entered does not match the one we sent you"
msgstr "Koden du oppga stemmer ikke med den vi har sendt deg"

msgid "The coupons have been activated!"
msgstr "Kupongene er aktivert!"

msgid "The day before your appointment, you'll receive an SMS with a more precise estimated time window. You’ll also get a notification when you are next on the list."
msgstr "Dagen før avtalen din vil du motta en SMS med et mer nøyaktig estimert tidsvindu. Du vil også få en varsling når du er neste på listen."

msgid "The job is done!"
msgstr "Jobben er fullført!"

msgid "The page you are looking for has either been moved or no longer exists. If we have linked incorrectly, we would be very happy if you send us a message."
msgstr "Siden du leter etter har enten blitt flyttet eller eksisterer ikke lenger. Hvis vi har lenket feil, ville vi bli veldig glade hvis du sender oss en melding."

msgid "The password must be at least 8 characters long"
msgstr "Passordet må være minst 8 tegn langt."

msgid "The payment of this booking is handled by invoice"
msgstr "Betalingen for denne bestillingen håndteres via faktura"

msgid "The time didn't work"
msgstr "Tidspunktet passet ikke"

msgid "The tires have been mounted on the your car."
msgstr "Dekkene har blitt montert på bilen din."

msgid "They are estimated to arrive at our warehouse on"
msgstr "De er estimert å ankomme vårt lager den"

msgid "This booking cannot be changed or canceled due to the proximity to the start time. For questions, contact us at hei@noddi.no"
msgstr "Denne bookingen kan ikke endres eller avbestilles på grunn av kort tid til jobben startes. For spørsmål, kontakt oss på hei@noddi.no"

msgid "This booking is listed as cancelled in our systems."
msgstr "Denne bookingen er registrert som kansellert i våre systemer."

msgid "This field is required"
msgstr "Dette feltet må fylles ut"

msgid "This field must be at least 2 characters long"
msgstr "Dette feltet må være minst 2 tegn langt."

msgid "This promotion is only for new users without existing coupons"
msgstr "Denne kampanjen er kun for nye brukere uten eksisterende kuponger"

msgid "This vehicle type is not supported"
msgstr "Denne kjøretøytypen støttes ikke"

msgid "Time"
msgstr "Tid"

msgid "Time for new tires?"
msgstr "På tide med nye dekk?"

msgid "Time window"
msgstr "Tidspunkt"

msgid "Tire hotel"
msgstr "Dekkhotell"

msgid "Tire hotel renewal"
msgstr "Fornyelse av dekkhotell"

msgid "Tire hotel with wheel change"
msgstr "Dekkhotell med dekkskift"

msgid "Tire not found"
msgstr "Dekk ikke funnet"

msgid "Tire offer"
msgstr "Dekktilbud"

msgid "Tires"
msgstr "Dekk"

msgid "Tires arrived"
msgstr "Dekkene har ankommet"

msgid "Tires mounted"
msgstr "Dekk montert"

msgid "Tires ordered"
msgstr "Dekk bestilt"

msgid "To activate your benefits, we first need to verify your phone number"
msgstr "For å aktivere fordelene dine, må vi først verifisere telefonnummeret ditt"

msgid "To book this combination, please create two separate bookings."
msgstr "Vennligst opprett to separate bestillinger for å bestille denne kombinasjonen."

msgid "Today"
msgstr "I dag"

msgid "Tomorrow"
msgstr "I morgen"

msgid "Total"
msgstr "Totalt"

msgid "Total of"
msgstr "Sum av"

msgid "Total sum including VAT"
msgstr "Total sum, inkl. mva."

msgid "Try again"
msgstr "Prøv igjen"

msgid "Unavailable combination"
msgstr "Utilgjengelig kombinasjon"

msgid "Unavailable items"
msgstr "Utilgjengelige tjenester"

msgid "Unfortunately, we don't have offer any addons for the services you've selected on this car"
msgstr "Dessverre tilbyr vi ingen tilleggstjenester for denne bilen gitt tjeneste du har valgt"

msgid "Unpaid"
msgstr "Ubetalt"

msgid "Upcoming bookings"
msgstr "Kommende bestillinger"

msgid "Update address"
msgstr "Oppdater adresse"

msgid "Updates"
msgstr "Oppdateringer"

msgid "Updating your booking"
msgstr "Oppdaterer din bestilling"

msgid "Used"
msgstr "Brukt"

msgid "Used another service"
msgstr "Brukte en annen tjeneste"

msgid "user_not_naf_member"
msgstr "Vi kan dessverre ikke finne deg i medlemsregisteret til NAF. Du må være medlem for å kunne aktivere fordeler. Ved feil, ta kontakt på hei@noddi.no"

msgid "user_phone_or_email_already_exists"
msgstr "Det ser ut som det allerede eksisterer en bruker med denne e-posten. Ta kontakt med oss på hei@noddi.no hvis du er stengt ute fra brukeren din."

msgid "VAT"
msgstr "Mva."

msgid "View offer"
msgstr "Se tilbud"

msgid "View order"
msgstr "Vis bestilling"

msgid "View status"
msgstr "Se status"

msgid "VIN/Chassi"
msgstr "VIN/Chassi"

msgid "Wash services"
msgstr "Vasketjenester"

msgid "We are preparing your appointment"
msgstr "Vi forbereder avtalen din"

msgid "We bring your stored tires, change them, and store the ones we take off"
msgstr "Vi henter de lagrede dekkene dine, skifter dem, og lagrer de vi tar av"

msgid "We change your wheels and take care of the tires you're not using. Safely stored until next season"
msgstr "Vi bytter til sesongens dekk og tar vare på de andre dekkene dine - trygt lagret til frem til neste dekkskift"

msgid "We couldn’t find the address. Please check for typos or missing details and try again!"
msgstr "Vi fant ikke adressen. Se etter skrivefeil eller mangler og prøv igjen!"

msgid "We couldn't find the car you searched for in the national vehicle registry"
msgstr "Vi kunne ikke finne bilen du søkte etter i det nasjonale kjøretøyregisteret"

msgid "We do not offer these services at this address"
msgstr "Vi tilbyr ikke disse tjenestene på denne adressen"

msgid "We do not provide tire hotel services in this area"
msgstr "Vi tilbyr ikke dekkhotell-tjenester i dette området."

msgid "We had trouble updating your booking. Please try again"
msgstr "Vi har problemer med å oppdatere bestillingen din. Vennligst prøv igjen"

msgid "We had trouble updating your booking. Please try again."
msgstr "Vi hadde problemer med å oppdatere bestillingen din. Vennligst prøv igjen"

msgid "We have prepared some options for new tires for {carName}. The offer is based on the tire dimensions the car is registered with at the Norwegian Public Roads Administration. We verify that these match before ordering."
msgstr "Vi har forberedt noen alternativer for nye dekk til {carName}. Tilbudet er basert på dekkdimensjonene bilen er registrert med hos Statens vegvesen. Vi verifiserer at disse stemmer før vi bestiller."

msgid "We have your tires stored with us"
msgstr "Vi har dekkene dine lagret hos oss"

msgid "We hope to see you back again soon"
msgstr "Vi håper å se deg tilbake snart"

msgid "We recommend"
msgstr "Vi anbefaler"

msgid "We wash with a steamer, so we have no need for access to water"
msgstr "Vi rengjør med dampmaskin – det betyr at vi ikke trenger tilgang til vann der vi jobber"

msgid "We were unable to complete this booking. Please contact us for more information."
msgstr "Vi kunne ikke fullføre denne bestillingen. Vennligst kontakt oss for mer informasjon."

msgid "We will be in touch with you shortly"
msgstr "Vi tar kontakt med deg snart"

msgid "We will be in touch with you shortly when we have ordered the tires!"
msgstr "Vi vil ta kontakt med deg snart når vi har bestilt dekkene!"

msgid "We will create a user for you, if you do not have one"
msgstr "Vi oppretter en bruker til deg hvis du ikke har en fra før"

msgid "We will keep you updated about when we arrive"
msgstr "Vi vil holde deg oppdatert om når vi ankommer"

msgid "We will notify you when the tires are ordered"
msgstr "Vi vil varsle deg når dekkene er bestilt"

msgid "We'll bring your tires and do the wheel change right at your home to end the tire hotel contract"
msgstr "Vi tar med dekkene dine og bytter hjemme hos deg for å avslutte dekkhotellavtalen"

msgid "We'll collect your tires from another tire hotel before bringing them to you"
msgstr "Vi henter dekkene dine fra et annet dekkhotell før vi leverer dem til deg"

msgid "We'll fix it where you are parked, bringing all the necessary tools"
msgstr "Vi fikser punkteringen der du står parkert, og tar med alle nødvendige verktøy"

msgid "We'll help you carry your tires to and from the car"
msgstr "Vi hjelper deg med å bære dekkene til og fra bilen"

msgid "We'll remove the tire offer from your homepage. Remember, safe tires are essential for staying safe on the road."
msgstr "Vi vil fjerne dekktilbudet fra hjemmesiden din. Husk, trygge dekk er avgjørende for å holde seg trygg på veien."

msgid "We'll send you an SMS the day before your scheduled booking with an estimated time of arrival. This will be based on our finalized route for the technicians, giving you a better idea of when to expect us. Additionally, we'll send you another shortly before we arrive."
msgstr "Vi sender deg en SMS dagen før din booking med estimert ankomsttid innenfor valgt leveringsluke. Dette er basert på din plass i teknikerens rute, slik at du får en bedre idé om når du kan forvente oss. Vi sender deg også en SMS kort tid før vi ankommer."

msgid "We'll text you the day before with estimated arrival time and when you're next on the list"
msgstr "Du får en SMS med estimert tid dagen før og når du er neste på listen"

msgid "We're sorry you had to cancel! Would you like to share the reason with us?"
msgstr "Så synd at du måtte kansellere! Ønsker du å dele grunnen med oss?"

msgid "We're sorry, an error has occurred"
msgstr "Vi beklager, det har oppstått en feil"

msgid "Weight"
msgstr "Tyngde"

msgid "Welcome back!"
msgstr "Velkommen tilbake!"

msgid "Wet grip"
msgstr "Våtgrep"

msgid "What can we help you with?"
msgstr "Hva kan vi hjelpe deg med?"

msgid "What happens next?"
msgstr "Hva skjer videre?"

msgid "Wheel change"
msgstr "Dekkskift"

msgid "Wheel services"
msgstr "Dekktjenester"

msgid "Wheel storage"
msgstr "Dekkhotell"

msgid "When is it convenient for us to come to you?"
msgstr "Når passer det at vi kommer til deg?"

msgid "When your tires are ready, we will contact you to schedule the installation."
msgstr "Når dekkene dine er klare, vil vi kontakte deg for å avtale tid for monteringen."

msgid "Where do you need our help?"
msgstr "Hvor skal vi hjelpe deg?"

msgid "Where should we pick up your tires?"
msgstr "Hvor skal vi hente dekkene dine?"

msgid "Why am I not able to select this?"
msgstr "Hvorfor kan jeg ikke velge dette?"

msgid "Width"
msgstr "Width"

msgid "winter tires"
msgstr "vinterdekk"

msgid "Winter tires"
msgstr "Vinterdekk"

msgid "Worn out"
msgstr "Må byttes"

msgid "Yes, remove the offer"
msgstr "Ja, fjern tilbudet"

msgid "You are now entering god mode👨 Good luck and be careful!"
msgstr "Du går nå inn i gudmodus👨 Lykke til, og vær forsiktig!"

msgid "You both get 150 kroner discount"
msgstr "Begge får 150 kroner i rabatt på neste bestilling"

msgid "You can book these services to your address"
msgstr "Du kan bestille disse tjenestene"

msgid "You can make changes to your agreement free of charge until 6:00 PM the day before. After this, a change fee may apply."
msgstr "Du kan gjøre endringer på avtalen kostnadsfritt frem til klokken 18:00 dagen før. Etter dette kan det komme et gebyr."

msgid "You can now make a new booking with your coupons."
msgstr "Du kan nå lage en ny booking med kupongene dine."

msgid "You can read more about our membership programs"
msgstr "Du kan lese mer om våre medlemsfordeler"

msgid "You currently don't have any tire offers - if you would like to get a tire offer, please contact us at"
msgstr "Du har for øyeblikket ingen dekktilbud. Dersom du ønsker å få et tilbud tilsendt vennligst kontakt oss på"

msgid "You don't have to be home when we arrive. If you have an interior wash, we need access to unlock the car. If you leave the key out, it is at your own risk."
msgstr "Du trenger ikke være hjemme når vi kommer. Om du har innvendig vask behøver vi tilgang til å låse opp bilen. Om du legger ut nøkkelen er det på eget ansvar."

msgid "You have"
msgstr "Du har"

msgid "You have already accepted this tire offer"
msgstr "Du har allerede akseptert dette tilbudet på dekk."

msgid "You have been invited by"
msgstr "Du har blitt invitert av"

msgid "You have not referred any users yet"
msgstr "Du har ikke vervet noen brukere enda."

msgid "You have selected"
msgstr "Du har valgt"

msgid "You need to log in in order to confirm the order"
msgstr "Du må logge inn for å bekrefte bestillingen."

msgid "You will be notified when we are on our way to you!"
msgstr "Du vil få beskjed når vi er på vei til deg!"

msgid "You will receive a text message when we are on our way to you, typically 10 to 30 minutes before arrival. This also includes your technician's mobile number in case you need to get in touch."
msgstr "Du får sms når vi er på vei til deg, typisk 10 til 30 minutter før ankomst. Denne inneholder også mobilnummer til teknikeren din om du behøver å komme i kontakt."

msgid "You'll receive an SMS confirmation with your booking details within the next few minutes. If you need to change the time of your booking, you can do so through your account."
msgstr "Du vil motta en SMS-bekreftelse med dine bookingdetaljer innen noen få minutter. Hvis du trenger å endre tidspunktet for bookingen, kan du gjøre det via din konto."

msgid "You'll receive an SMS confirmation with your order details within the next few minutes."
msgstr "Du vil motta en SMS-bekreftelse med bestillingsdetaljene dine i løpet av de neste få minuttene."

msgid "You've tried too many times, so we've temporarily blocked your request. If you need help, please contact us at hei@noddi.no"
msgstr "Du har prøvd for mange ganger, så vi har midlertidig blokkert forespørselen din. Hvis du trenger hjelp, vennligst kontakt oss på hei@noddi.no"

msgid "Your booking"
msgstr "Din bestilling"

msgid "Your bookings"
msgstr "Dine bestillinger"

msgid "Your delivery window is not available in this address"
msgstr "Ditt leveringsvindu er ikke tilgjengelig på denne adressen"

msgid "Your order"
msgstr "Din bestilling"

msgid "Your order has been confirmed and paid."
msgstr "Din bestilling er bekreftet og betalt."

msgid "Your order has been confirmed. Please pay for your order in order for us to process it."
msgstr "Din bestilling er bekreftet. Vennligst betal for din bestilling slik at vi kan behandle den."

msgid "Your order is confirmed and paid!"
msgstr "Din bestilling er bekreftet og betalt!"

msgid "Your order is confirmed!"
msgstr "Din bestilling er bekreftet!"

msgid "Your profile does not have a registered phone number. Contact customer service and we will fix it for you"
msgstr "Profilen din har ikke registrert telefonnummer. Kontakt kundeservice, så fikser vi det for deg."

msgid "Your session has expired. Try refreshing the page, or sign in again in a new browser tab"
msgstr "Økten din har utløpt. Prøv å oppdatere siden, eller logg inn igjen i en ny nettleserfane"

msgid "Your shopping cart"
msgstr "Din handlekurv"

msgid "Your suggested booking is no longer available, feel free to create a new booking"
msgstr "Din foreslåtte bestilling er ikke lenger tilgjengelig. Du er hjertelig velkommen til å legge inn en ny bestilling"

msgid "Your tire order"
msgstr "Din dekkbestilling"

msgid "Your tires are on the way"
msgstr "Dekkene dine er på vei"

msgid "Your tires have arrived safely and we're ready to get them mounted. All that's left for you to do is choose the time and location that work best for you. We'll take care of the rest."
msgstr "Dekkene dine har ankommet trygt, og vi er klare til å montere dem. Alt som gjenstår for deg er å velge tid og sted som passer best for deg. Vi tar oss av resten."

msgid "Your tires have arrived. We will contact you to book an appointment to have them mounted on your car."
msgstr "Dine dekk har ankommet. Vi vil ta kontakt for å avtale time for montering på bilen din."

msgid "Your user cannot activate coupons from this campaign"
msgstr "Din bruker kan ikke aktivere kuponger fra denne kampanjen"
